module.exports = __webpack_public_path__ + "img/3a6d713ad115b39cbc6594a145a99f3.f024f69d.jpg";